import { createContext, useContext } from 'react';

const ErrorContext = createContext({});
const useErrorHandler = () => {
    const errorHandler = useContext(ErrorContext);
    return errorHandler;
};

export { ErrorContext as default, useErrorHandler };
//# sourceMappingURL=ErrorContext.js.map
